import React, { Component } from "react";
import Container from "../components/container";
import HeroSmall from "../components/hero-small";

const defaultState = {
  name: "",
  email: "",
  subject: "",
  message: ""
 }

class Contact extends Component {
  state = defaultState;
 
  onChange = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    })
  }

  resetForm = evt => {
    this.setState(defaultState);
  }

  onSubmit = evt => {
    evt.preventDefault();
    if(this.state!==defaultState) {
      fetch("http://webbholding.me/send-mail.php", {
      method: "POST",
      body: JSON.stringify(this.state)
    })
    .then(res => {
      this.resetForm();
      alert("Message succesfully sent!")
    })
    .catch(res=>{
      alert("Error happend. Please try again later.")
    })
    }
    
  }

  render() {
    return (
      <main className="contact-page">
        <HeroSmall
          title="Contact Us"
          desc="We want to hear from you"
        />

        <Container>
          <h1 style={{ paddingTop: "50px" }}>Drop us a line. We'd love to chat!</h1>
        </Container>

        <Container customClassName="page-container">
          <div className="page-sixth-contact">
            <div className="contact-form">
              <form>
                <div className="row">
                  <div className="half">
                    <input onChange={this.onChange} type="text" value={this.state.name} name="name" placeholder="Name" />
                  </div>
                  <div className="half">
                    <input onChange={this.onChange} type="email" value={this.state.email}  name="email" placeholder="E-mail" />
                  </div>
                </div>
                <input onChange={this.onChange} type="text" value={this.state.subject}  name="subject" placeholder="Subject" />
                <textarea onChange={this.onChange} name="message" value={this.state.message}  placeholder="Message"></textarea>
                <input onClick={this.onSubmit} type="button" className="button-purple" value="Send" />
              </form>
            </div>
          </div>

          <div className="page-third">
            <h4>Contact Info</h4>
           

            <ul>
              <li>E-mail: info@webbholding.me</li>
              <li>Website: www.webbholding.me</li>
            </ul>
          </div>
        </Container>
      </main>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js